export class CreateApprovalInput {
  companyId?: string;
  id?: string;
  contractNumber?: string;
  agreedTripNumber?: string;
  issueDate?: string;
  validFrom?: string;
  validUntil?: string;
  issueAddress?: string;
  authorizedRoute?: string;
  authorizedGoods?: string;
  isAuthorized?: boolean;
  reason?: string;
}
